import * as React from 'react';

interface MultiIntegrationIconProps {
    size?: number;
    // Defaults to currentColor so callers can theme it (e.g. runwayColors.black,
    // which resolves to the text token and adapts to dark mode). The 0.5 opacity
    // is part of the icon's design.
    color?: string;
}

const MultiIntegrationIcon: React.FC<MultiIntegrationIconProps> = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
        <g opacity="0.5" clipPath="url(#clip0_multi_integration)">
            <path
                d="M24.0625 12.8125H19.1875V7.9375C19.1875 7.73125 19.0188 7.5625 18.8125 7.5625H7.9375C7.73125 7.5625 7.5625 7.73125 7.5625 7.9375V18.8125C7.5625 19.0188 7.73125 19.1875 7.9375 19.1875H12.8125V24.0625C12.8125 24.2688 12.9812 24.4375 13.1875 24.4375H24.0625C24.2688 24.4375 24.4375 24.2688 24.4375 24.0625V13.1875C24.4375 12.9812 24.2688 12.8125 24.0625 12.8125ZM12.8125 13.1875V17.5938H9.15625V9.15625H17.5938V12.8125H13.1875C12.9812 12.8125 12.8125 12.9812 12.8125 13.1875ZM17.5938 14.4062V17.5938H14.4062V14.4062H17.5938ZM22.8438 22.8438H14.4062V19.1875H18.8125C19.0188 19.1875 19.1875 19.0188 19.1875 18.8125V14.4062H22.8438V22.8438Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_multi_integration">
                <rect width="24" height="24" fill="white" transform="translate(4 4)" />
            </clipPath>
        </defs>
    </svg>
);

export default MultiIntegrationIcon;
